// src/pages/AdminServicesPage.jsx
import AdminServicesPageComponent from "../components/admin/AdminServicesPage";

export default function AdminServicesPage() {
  return <AdminServicesPageComponent />;
}